



import ILanguageDto from "./LanguageDto.if";
import mappings from "./LanguageDto.map";
import Transformers from './private/transformer';


export default (data: object) => { return Transformers.create<ILanguageDto>(mappings, data); }
